/**
 * loại chứng từ
 */
export default {
  /* -----------------------------------------------------
  Cấu hình RefType load service cho button print Panda
   ------------------------------------------------------ */

  // Phiếu thu
  CashReceipt: 20,
  // Phiếu chi
  CashPayment: 21,
  // Séc
  Cheque: 40,
  // Phiếu nộp tiền vào tài khoản
  Deposit: 41,
  // Phiếu nhập kho
  InwardStock: 60,
  // Phiếu xuất kho
  OutwardStock: 61,
  // Chuyển kho nội bộ
  AssetTransfer: 62,
  // Phiếu kết chuyển tài khoản 
  AccountTransferSlipVoucher: 70,
  // Phân phối tiền thu
  JusticeReceiptAllocation: 71,
  // Phân phối tiền bán tài sản
  JusticeSellingAllocation: 72,
  // Chứng từ nghiệp vụ khác
  GeneralJournalEntry: 80,
  // Phiếu xác định tiền, giá trị TSTV
  AssetEvaluation: 98
};
